module.exports = __webpack_public_path__ + "static/media/img-approval.b119aeb2.png";